module.exports = __webpack_public_path__ + "img/Unit_Guide_wine.cf86b19c.svg";